import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from './api'

interface LoginParams {
  name?: string;
  email: string;
  // 1 —— 谷歌登录 2 —— 邮箱登录
  login_method: 1 | 2;
  third_party_session_id?: string;
  email_session_id?: string;
  email_verification?: string;
  rsa_id?: string;
  activation_code?: string;
  invite_token?: string;
  agent_id?: string;
}

export interface LoginProps {
  name?: string;
  email: string;
  loginMethod: 1 | 2;
  thridPartySessionId?: string;
  emailSessionId?: string;
  emailVerification?: string;
  rsaId?: string;
  activationCode?: string;
  inviteToken?: string;
  agentId?: string;
}

// 原始接口
interface LoginResponse {
  token: string;
}

// 主数据类
export class LoginData {
  @Required("Token cannot be empty")
  @IsString("Token must be a string")
  token: string;
}

const transformAndValidateLogin = (
  response: LoginResponse
): LoginData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, LoginData);
  } catch (error) {
    console.error("Login data validation failed:", error.message);
    throw error;
  }
};

// 邮箱登录
export const login = async (props: LoginProps): Promise<LoginData> => {
  const params: LoginParams = {
    name: props.name,
    email: props.email,
    // 1 —— 谷歌登录 2 —— 邮箱登录
    login_method: props.loginMethod,
    third_party_session_id: props.thridPartySessionId,
    email_session_id: props.emailSessionId,
    email_verification: props.emailVerification,
    rsa_id: props.rsaId,
    activation_code: props.activationCode,
    invite_token: props.inviteToken,
    agent_id: props.agentId
  };
  const response = await api.post<LoginResponse>('/login', params);
  const validatedData = transformAndValidateLogin(response.data);
  return validatedData;
}
